import React, { useRef, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { AppleStore } from "../components/appleStore";
import { PlayStore } from "../components/playStore";
import doryWhite from "../assets/doryWhite.png";

// Import the video directly
import backgroundVideo from "../assets/vids/sample.mp4";

export const LandingPage = () => {
  const controls = useAnimation();
  const videoRef = useRef(null);

  useEffect(() => {
    controls.start({
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 },
    });

    // Ensure video plays
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error("Video play failed:", error);
      });
    }
  }, [controls]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.3 },
    },
  };

  const floatVariants = {
    float: {
      y: [0, -8, 0],
      transition: {
        repeat: Infinity,
        repeatType: "reverse",
        duration: 1.2,
      },
    },
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-white p-4 relative overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full z-0">
        <div className="absolute inset-0 bg-black/65 z-10" />{" "}
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          src={backgroundVideo}
        >
          <div className="absolute inset-0 bg-[#00BF64] z-0" />
        </video>
      </div>
      <motion.div
        className="container mx-auto flex flex-col items-center justify-center text-center relative z-20 px-4 md:px-6 lg:px-8"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <motion.div
            variants={floatVariants}
            animate="float"
            className="flex items-center"
          >
            <img
              src={doryWhite}
              alt="Dory Logo"
              className="w-16 h-16 sm:w-20 sm:h-20 md:w-25 md:h-25 object-contain mt-6 sm:mt-10"
            />
          </motion.div>

          <motion.h1
            className="text-4xl sm:text-5xl md:text-6xl font-black font-poppins flex items-center mt-4 sm:mt-10 text-[#00c164] tracking-wide drop-shadow-lg"
            variants={itemVariants}
          >
            DORY PH
          </motion.h1>
        </div>
        <div className="max-w-2xl mx-auto px-4">
          <motion.h2
            className="text-2xl sm:text-3xl font-bold italic mt-6 sm:mt-8 mb-4 sm:mb-6 text-[#e0fff2]"
            variants={itemVariants}
          >
            "Your Door to Door Delivery"
          </motion.h2>

          <motion.p
            className="text-lg sm:text-xl font-bold mt-6 sm:mt-8 mb-4 sm:mb-6 leading-relaxed"
            variants={itemVariants}
          >
            Fast, Reliable, and Affordable Delivery at Your Doorstep.
          </motion.p>

          <motion.p
            className="text-base sm:text-lg mt-4 sm:mt-6 mb-6 sm:mb-8 font-light text-[#e6ffe6]"
            variants={itemVariants}
          >
            So what are you waiting for?{" "}
            <span className="font-bold">Get our App now!</span>
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-12 sm:mb-16 mt-6 sm:mt-10"
            variants={itemVariants}
          >
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 500, damping: 8 }}
            >
              <PlayStore />
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 500, damping: 8 }}
            >
              <AppleStore />
            </motion.div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};
